import { IconButton } from '@material-ui/core';
import React from 'react';

import { MoreActionsMenu } from './MoreActionsMenu';
import { ActionsOption } from './types/ActionsOption';

export const MoreActionsMenuWithIcon = ({
  actionsOptionsArray,
  style,
  iconButtonProps,
}: {
  actionsOptionsArray: ActionsOption[];
  style?: React.CSSProperties;
  iconButtonProps?: React.ComponentProps<typeof IconButton>;
}) => {
  return (
    <>
      <MoreActionsMenu actionsOptionsArray={actionsOptionsArray} style={style}>
        <IconButton size={'small'} className={'ml-2'} {...iconButtonProps}>
          {<i className="material-icons-outlined">more_horiz</i>}
        </IconButton>
      </MoreActionsMenu>
    </>
  );
};
